import { FieldMergeFunction, FieldPolicy } from '@apollo/client/cache';
import { DateTime } from 'luxon';

const dateTimeMergeFunction: FieldMergeFunction<string | DateTime | null | undefined> = (_, incoming) => {
  if (incoming === null || incoming === undefined) {
    return incoming;
  }

  if (incoming instanceof DateTime) {
    return incoming;
  }

  return DateTime.fromISO(incoming as string);
};

export const dateTimeFieldPolicy: FieldPolicy = {
  merge: dateTimeMergeFunction,
};
